import 'angular';

import uploadDirective from './upload';

const MODULE_NAME = 'daupler.incidents.components.buttons.files';

var app = angular.module(MODULE_NAME, [
	'ngFileUpload',
]);
app.directive('uploadFile', uploadDirective);


export default MODULE_NAME;
